import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=f84ea09c&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=ts"
export * from "./Privacy.vue?vue&type=script&lang=ts"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=f84ea09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84ea09c",
  null
  
)

export default component.exports